<h1 mat-dialog-title>Oh no!</h1>

<div mat-dialog-content>
  <p>
    Purtroppo si è verificato un errore.
    <br />
    Non siamo sicuri di poter salvare le tue ultime modifiche, ci dispiace!
  </p>
  <pre>
    {{ error?.message }}
  </pre>
  <p>
    Per favore, inviaci una segnalazione cliccando il bottone "INVIA
    SEGNALAZIONE" qui sotto, così potremo migliorare la tua esperienza di
    utilizzo di MyQuoVado.
    <br />
    Ti consigliamo di ricaricare la pagina.
  </p>
  <br />
  <small>{{ appVersion }}</small>
</div>
<div mat-dialog-actions>
  <a color="primary" href="mailto:info@quovado.com?subject=Segnalazione errore su My QuoVado: {{
      error.message
        ? ': ' + error.message.toString().substring(0, 100) + '...'
        : ''
    }}&body={{ appVersion }} --- {{ userAgent }} --- {{ error?.stack }}" mat-button (click)="close()">Invia
    Segnalazione</a>
  <span fxFlex></span>
  <button mat-raised-button color="primary" (click)="close()" cdkFocusInitial>
    Ok
  </button>
</div>